import { call } from 'redux-saga/effects';
import { parseQueryString } from '../../../../utils/helperFunctions';
import notify from '../../../helpers/notify';
import request from '../../../helpers/request';
import { SHOW_RANKING_INDICATORS } from '../constants';

const getRankingIndicatorNotifier = (params, loader = false, callback) =>
  notify({
    type: SHOW_RANKING_INDICATORS,
    params,
    loader,
    callback,
  });

function* getRankingIndicatorAction({ params, callback }) {
  const strQueryParams = parseQueryString(params);
  yield call(request, {
    type: SHOW_RANKING_INDICATORS,
    method: 'get',
    endpoint: `/indicators/getRankings${strQueryParams}`,
    callback,
  });
}

export { getRankingIndicatorAction, getRankingIndicatorNotifier };
